import type { GetServerSideProps } from 'next';

const getServerSideProps: GetServerSideProps = async (context) => ({
  redirect: {
    destination: context.resolvedUrl.replace(/\/picks$/, '/pick'),
    pernament: true,
  },
  props: {},
});

function Picks(): React.ReactNode {
  return null;
}

export default Picks;

export { getServerSideProps };
